import { createSelector } from "@reduxjs/toolkit";
import { StoreState } from "../../store";

const selector = (state: StoreState) => state.group;

export const groupSelectors = {
  groups: createSelector(selector, (group) => group.groups),
};
